import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {PageCreate} from 'src/app/shared/models/page.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'form-sub-page',
    templateUrl: 'form-sub-page.html'
})

export class FormSubPageComponent implements OnInit, OnDestroy {

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService) {
    }

    pageForm: FormGroup;

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.pageForm = new FormGroup({
            'title': new FormControl(),
            'url': new FormControl(),
            'text_content': new FormControl()
        });
    }

    onSubmit() {
        const value = this.pageForm.value;
        const newPage = new PageCreate(value.title, value.text_content, value.url);
        this.dataStorageService.createPage(newPage)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
                if (responseData['error']) {
                    console.log('adding sub page error');
                } else {
                    alert('sub page added. ');
                    location.reload();
                }
            });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
